export default [
    {
        name: 'Onze Photobooths',
        to: '/gifture-photobooths',
        // children: [
        //     {
        //         name: 'Gifture \'Retro\'',
        //         to: '/gifture-retro'
        //     },
        //     {
        //         name: 'Gifture \'Koekoek\'',
        //         to: '/gifture-zaans-huisje'
        //     },
        //     {
        //         name: 'Gifture \'diy\'',
        //         to: '/gifture-diy'
        //     }
        // ]
    },
    // {
    //     name: 'Gallerij',
    //     to: '/gallerij'
    // },
    // {
    //     name: 'Personaliseer',
    //     to: '/personaliseer',
    //     label: {
    //         type: 'new',
    //         content: 'Nieuw!'
    //     }
    // },
    // {
    //     name: 'Prijzen',
    //     to: '/prijzen'
    // },
    {
        name: 'Reserveren',
        to: '/reserveren'
    },
    {
        name: 'Contact',
        to: '/contact'
    }
];


// WEBPACK FOOTER //
// ./src/config/navbarItems.js